/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Home_Faq_3Inputs */

const en_settings_home_faq_3 = /** @type {(inputs: Settings_Home_Faq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the email address in your Associated Users table. You can
            resend the invitation by clicking the more icon next to the invited
            user. Still having issues? Contact us at`)
};

/**
* | output |
* | --- |
* | "Check the email address in your Associated Users table. You can resend the invitation by clicking the more icon next to the invited user. Still having issues..." |
*
* @param {Settings_Home_Faq_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_3 = /** @type {((inputs?: Settings_Home_Faq_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_3(inputs)
});